const CAMPAIGN_ID_KEY = 'emailCampaignId';
const CAMPAIGN_EVENT_KEY = 'emailCampaignEventName';
/** Strips every character that is not safe to persist. The `.replace` result is what we store —
 * a regex `.test`/`.exec` on the original URL param is not a sanitizer for browser storage. */
const UNSAFE_STORAGE_CHARS = /[^A-Za-z0-9._-]/g;

function resolveStorage(storage) {
  return storage ?? globalThis.localStorage;
}

function sanitizeStorageValue(value) {
  if (typeof value !== 'string') return '';
  const trimmed = value.trim();
  if (!trimmed) return '';
  const sanitized = trimmed.replace(UNSAFE_STORAGE_CHARS, '');
  // Reject anything that needed stripping — do not persist a partial/mutated token.
  if (sanitized !== trimmed) return '';
  return sanitized;
}

function clearAttribution(storage) {
  storage.removeItem(CAMPAIGN_ID_KEY);
  storage.removeItem(CAMPAIGN_EVENT_KEY);
}

export function isValidEmailCampaignId(campaignId) {
  return sanitizeStorageValue(campaignId) !== '';
}

/**
 * Store campaign attribution for this visit, or drop a leftover id when this visit did not come
 * from a campaign email. Scoped to `eventName` so a later purchase on a different event cannot
 * inherit the tag. Checkout pages do not re-run gallery init, so localStorage is what carries
 * the id from the gallery onto the line item.
 */
export function syncEmailCampaignAttribution(campaignId, eventName, storage) {
  const store = resolveStorage(storage);
  const safeCampaignId = sanitizeStorageValue(campaignId);
  const safeEventName = sanitizeStorageValue(eventName);
  if (safeCampaignId && safeEventName) {
    store.setItem(CAMPAIGN_ID_KEY, safeCampaignId);
    store.setItem(CAMPAIGN_EVENT_KEY, safeEventName);
    return;
  }
  clearAttribution(store);
}

/** Line-item tag for this event's campaign visit, or null when none / a different event. */
export function getEmailCampaignIdForEvent(eventName, storage) {
  const store = resolveStorage(storage);
  const safeEventName = sanitizeStorageValue(eventName);
  if (!safeEventName) return null;
  if (store.getItem(CAMPAIGN_EVENT_KEY) !== safeEventName) return null;
  return store.getItem(CAMPAIGN_ID_KEY) || null;
}
